import React from 'react'
import PropTypes from 'prop-types'
import StatusReportContextProvider from './statusReportContext'

function StatusReportProvider ({ children, config, variant, templateId, templatePurposeKey }) {
  return (
    <StatusReportContextProvider
      config={config}
      variant={variant}
      templateId={templateId}
      templatePurposeKey={templatePurposeKey}
    >
      {children}
    </StatusReportContextProvider>
  )
}

StatusReportProvider.propTypes = {
  children: PropTypes.node,
  config: PropTypes.shape({
    filtersAt: PropTypes.arrayOf(PropTypes.number),
    allItemsLabel: PropTypes.string
  }),
  variant: PropTypes.oneOf(['default', 'board']),
  templateId: PropTypes.number,
  templatePurposeKey: PropTypes.string
}

StatusReportProvider.defaultProps = {
  variant: 'default'
}

export default StatusReportProvider
